import { render } from "./Deductions.vue?vue&type=template&id=e5c2f6bc"
import script from "./Deductions.vue?vue&type=script&lang=js"
export * from "./Deductions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__